/**
 * Imperative navigation reference.
 *
 * Anything that needs to navigate from outside a React component (auth
 * context, api client on 401, toast handlers, deep-link handlers, etc.)
 * should go through this ref.  It is attached to the <NavigationContainer>
 * in App.tsx and becomes "ready" the moment the container mounts.
 *
 * See src/compat/router.tsx for the expo-router-shaped facade that wraps
 * this ref.
 */
import { createNavigationContainerRef } from '@react-navigation/native';
import type { ParamListBase } from '@react-navigation/native';

export const navigationRef = createNavigationContainerRef<ParamListBase>();

export function safeDispatch(action: any) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(action);
  }
}
